import { Trans } from '@lingui/macro'
import { BackButton, ButtonOutline } from 'front-end/src/components'
import {
  Topbar,
  TopbarLeft,
  TopbarRight,
  TopbarTitle
} from 'front-end/src/components/common/topbar/Topbar'
import React from 'react'
import { navigateTo } from '../../../app/util/appHistory'
import { staticLinks } from '../../../../../shared/linkBuilder'

export const ManagePathwaysTopbar = () => {
  return (
    <Topbar>
      <TopbarLeft>
        <BackButton mr="4px" />
        <TopbarTitle>
          <Trans>Pathways</Trans>
        </TopbarTitle>
      </TopbarLeft>
      <TopbarRight>
        <ButtonOutline
          onClick={() => navigateTo(staticLinks.pathways)}
          px="12px"
        >
          <Trans>View pathways</Trans>
        </ButtonOutline>
      </TopbarRight>
    </Topbar>
  )
}
